import React from "react";

export const FooterLink = ({ title }) => {
  return (
    <div className="flex gap-x-2 my-2 font-semibold cursor-pointer">
      <p>*</p>
      <p className="hover:text-gray-100 hover:underline">{title}</p>
    </div>
  );
};

const MainFooter = () => {
  return (
    <div
      className="text-gray-400 px-2 md:px-32 p-10 pt-10 "
      style={{ backgroundColor: "#002147" }}
    >
      <div className="flex flex-wrap md:flex-nowrap justify-between py-6">
        {/** First */}
        <div>
          <h4 className="mb-5">INFORMATION ABOUT</h4>
          <div>
            <FooterLink title="History" />
            <FooterLink title="Administarttion" />
            <FooterLink title="Our Campus" />
            <FooterLink title="Cafeteria" />
            <FooterLink title="Our Teachers" />
            <FooterLink title="Academic Calender" />
            <FooterLink title="Contact Us" />
          </div>
        </div>
        {/** Second */}
        <div>
          <h4 className="mb-5">INFORMATION FOR</h4>
          <div>
            <div>
              <FooterLink title="Admissions" />
              <FooterLink title="Schools" />
              <FooterLink title="Events" />
              <FooterLink title="News" />
              <FooterLink title="Application FAQ" />
              <FooterLink title="Donations" />
              <FooterLink title="Teachers" />
              <FooterLink title="Media" />
              <FooterLink title="Alumni" />
            </div>
          </div>
        </div>
        {/** Third */}
        <div>
          <h4 className="mb-5">QUICK LINKS</h4>
          <div>
            <FooterLink title="Academic Calender" />
            <FooterLink title="Research" />
            <FooterLink title="Timetable" />
            <FooterLink title="News List" />
            <FooterLink title="Events List" />
          </div>
        </div>
        {/** Fourth */}
        <div>
          <h1 className="mb-5">Logo Here</h1>
          <div>
            <FooterLink title="Raio, Udaipur, Gomati Tripura - 799114" />
            <FooterLink title="+ 987654321" />
            <FooterLink title="+ 876497202" />
            <FooterLink title="saintjohnschool@rediffmail.com" />
            <FooterLink title="Mon — Sat: 8AM — 2PM" />
          </div>
        </div>
      </div>
      <div className="border-t border-gray-400 p-3 text-center">
        <p>
          Copyright © St. John High School Built by TechAbide. All rights
          reserved
        </p>
      </div>
    </div>
  );
};

export default MainFooter;
